import getChangeStatusText from './getChangeStatusText'

const user = {
  getChangeStatusText,
}

export default user
